module.exports = __webpack_public_path__ + "static/media/lab_results.b3c6fab6.jpg";